module.exports = __webpack_public_path__ + "img/SUPEROK_4.076949a4.jpg";